import React, { useEffect, useReducer } from 'react'
import PropTypes from 'prop-types'
import {
  decimalFormat,
  qttInput,
  currencyFormat,
} from 'utils/format'
import {
  calculateDiscount,
  DISCOUNT_PERCENTAGE,
  DISCOUNT_VALUE,
} from 'utils/calculate-item-discount'
import { Confirm } from 'ui-components/Confirm'
import { Input } from 'ui-components/Input'
import { InputCurrency } from 'components/InputCurrency'
import { InputsContainer } from './styles'

const INITIAL_VALUES = {
  quantity: 0,
  value: 0,
  discount_value: 0,
  discount_percentage: 0,
}

const INIT_REDUCER = 'init'

const attrReducer = (state, action) => {
  if (action.type === INIT_REDUCER) return action.attributes

  const newState = {
    ...state,
    ...action.attributes,
  }

  const discount = calculateDiscount(action.type, newState)
  const name = action.type === DISCOUNT_PERCENTAGE
    ? 'discount_value'
    : 'discount_percentage'

  return {
    ...newState,
    [name]: discount,
  }
}

export default function EditItemForm(props) {
  const {
    item,
    open,
    onCancel,
    onSave,
    saving,
  } = props

  const [attributes, dispatch] = useReducer(attrReducer, INITIAL_VALUES)

  useEffect(() => {
    const attr = {
      quantity: item.quantity,
      value: currencyFormat(item.value),
      discount_value: item.discount_value,
      discount_percentage: Number(item.discount_percentage),
    }

    dispatch({ type: INIT_REDUCER, attributes: attr })
  }, [item])

  const handleChangeQtt = (evt) => {
    const { name, value } = evt.target

    const qtt = qttInput(value)

    dispatch({
      type: DISCOUNT_PERCENTAGE,
      attributes: { [name]: qtt },
    })
  }

  const handleChangeCurrency = (evt) => {
    const { name, value } = evt.target

    dispatch({
      type: DISCOUNT_PERCENTAGE,
      attributes: {
        [name]: value,
      },
    })
  }

  const handleChangeDiscountValue = (evt) => {
    const { name, value } = evt.target

    dispatch({
      type: DISCOUNT_VALUE,
      attributes: {
        [name]: value,
      },
    })
  }

  const handleChangeDiscountPercentage = (evt) => {
    const { name, value } = evt.target

    dispatch({
      type: DISCOUNT_PERCENTAGE,
      attributes: {
        [name]: value,
      },
    })
  }

  const handleSave = () => {
    const params = {
      ...attributes,
      value: decimalFormat(attributes.value),
      discount_value: decimalFormat(attributes.discount_value),
      discount_percentage: attributes.discount_percentage,
    }

    onSave(params)
  }

  return (
    <Confirm
      open={open}
      title="Alterar item"
      onCancel={onCancel}
      onConfirm={handleSave}
      cancelButtonText="Cancelar"
      confirmButtonText="Salvar"
      requesting={saving}
      type="warning"
    >
      <p>{item.item?.name}</p>

      <InputsContainer>
        <Input
          label="Quantidade"
          name="quantity"
          value={attributes.quantity}
          onChange={handleChangeQtt}
        />
        <InputCurrency
          label="Valor"
          name="value"
          value={attributes.value}
          onChange={handleChangeCurrency}
        />
        <InputCurrency
          label="Desconto %"
          name="discount_percentage"
          value={attributes.discount_percentage || '0'}
          onChange={handleChangeDiscountPercentage}
          min={0}
          max={100}
        />
        <InputCurrency
          label="Desconto R$"
          name="discount_value"
          value={attributes.discount_value}
          onChange={handleChangeDiscountValue}
        />
      </InputsContainer>
    </Confirm>
  )
}

EditItemForm.propTypes = {
  item: PropTypes.objectOf(PropTypes.any),
  open: PropTypes.bool,
  saving: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
}

EditItemForm.defaultProps = {
  item: {},
  open: false,
  saving: false,
}
